import {Card, Stack, Typography} from "@mui/material";
import React from "react";
import {formatCurrency, Pricing} from "../../../firebase/index.js";
import type {APXBaseOption, APXOptions} from "../../../reusables/APXMoreMenuWithPopover.jsx";
import APXMoreMenuWithPopover from "../../../reusables/APXMoreMenuWithPopover.jsx";
import {singleLineText} from "../../../reusables/js/APXCrucialStyles.js";
import {businessColour, productColour} from "../../../reusables/js/APXTheme.js";
import AddNewPriceBSL from "./AddNewPriceBSL.jsx";


export default function PricingCard({inBusiness, pp}: { inBusiness: boolean, pp: Pricing }) {
	  
	  const {businessName, productName, productVariantName, price, quantity, unit} = (pp: Pricing);
	  
	  const [openNewPriceDialog, setOpenNewPriceDialog] = React.useState(false);
	  
	  const menuOptions: APXOptions = {
			 updatePrice: {
					label: "Update Price",
					needsConfirmation: false,
					keepDisabled: false,
					onClick: () => {
						  setOpenNewPriceDialog(true);
					}
			 }
	  };
	  
	  return (
				 <>
						<Card variant={"outlined"} sx={{p: 2, my: 1, borderColor: inBusiness ? productColour : businessColour}}>
							  <Stack spacing={2} alignItems={"stretch"} justifyContent={"center"}>
									 <Stack direction="row" spacing={1} alignItems={"center"} justifyContent={"space-between"}>
											<Typography variant="body2" style={singleLineText}>{inBusiness ? `${productName} ${productVariantName}` : `${businessName}`}</Typography>
											<Stack direction="row" spacing={0.5} alignItems="center">
												  <Typography variant="body2" pr={2} style={singleLineText}>{formatCurrency(Number(price))}{` / ${quantity} ${unit}`}</Typography>
												  <APXMoreMenuWithPopover options={menuOptions}
																				  onConfirmedOptionSelected={(option: APXBaseOption) => option.onClick()}
												  />
											</Stack>
									 </Stack>
									 {openNewPriceDialog &&
												<AddNewPriceBSL pp={pp} onClose={() => setOpenNewPriceDialog(false)} uid={null /* PLACEHOLDER ONLY */}/>
									 }
							  </Stack>
						</Card>
				 </>
	  );
}
